import { toggleHighlightColorScheme } from './modules/color-scheme';
import { loadStageVisual } from './modules/helper';
import { classNames, elements, selectors, specificLvlThree } from './modules/init';
import { initScrollEvents } from './modules/scroll';

// Set the search in the main navigation to highlight.
const search = document.querySelector(selectors.search);
search && search.setAttribute('data-color-scheme', 'highlight');

const mobileOpenClass = (set = true) => {
	set ? elements.html.classList.add(classNames.mobileOpen) : elements.html.classList.remove(classNames.mobileOpen);
};

const handleNavClick = (element, selector, closestItem, clickOutsideListener = false) => {
	element.addEventListener('click', () => {
		const mobileCtr = document.querySelector(selectors.mobileNavSelector).closest(selectors.mobileNav);

		const clickOnBurger = element.classList.contains('menu');

		// Get the surrounding list element element
		const listItemCtr = element.closest(closestItem);

		if (listItemCtr.classList.contains(classNames.lvlOpen)) {
			// ! Click on a opened menu item.
			mobileOpenClass(false);

			listItemCtr.classList.remove(classNames.lvlOpen);

			if (!clickOutsideListener) {
				// The inner mobile navigation has no list, so the click must be directed to the mobile navigation.
				// Since this click is on an open element, the indicator must be removed.
				mobileCtr.classList.remove(classNames.mobileSelect);
			}
		} else {
			// ! Click on a menu item that is closed.

			mobileOpenClass(clickOnBurger);

			// Close other open menu item that needs to be closed first
			document.querySelector(`${selector}.${classNames.lvlOpen}`)?.classList.remove(classNames.lvlOpen);

			// Set the list element to active.
			listItemCtr.classList.add(classNames.lvlOpen);

			// Load the stage background if stage available.
			loadStageVisual(listItemCtr);

			// Add event listener to watch for clicks outside of the current active list item.
			if (clickOutsideListener) {
				window.addEventListener('click', checkForNavOutsideClicks);
			} else {
				// The inner mobile navigation has no list, so the click must be directed to the mobile navigation.
				// Since this click is on a closed element, the indicator must be added.
				mobileCtr.classList.add(classNames.mobileSelect);
			}
		}

		// Set body class
		if (!clickOnBurger) {
			const itemClasses = listItemCtr.classList;
			const bodyClasses = elements.body.classList;
			if (itemClasses.contains(classNames.lvl1) && itemClasses.contains(classNames.lvlOpen)) {
				bodyClasses.add(classNames.stageOpen);
				elements.nav.classList.add(classNames.bg);
			} else {
				bodyClasses.remove(classNames.stageOpen);

				if (window.scrollY === 0) {
					elements.nav.classList.remove(classNames.bg);
				}
			}
			toggleHighlightColorScheme();
		}
	});
};

const closeStage = () => {
	// Check if user clicks outside of the active menu item to close it again
	document.querySelector(`${selectors.primaryNavSelector}.${classNames.lvlOpen}`)?.classList.remove(classNames.lvlOpen);

	// Remove body class
	elements.body.classList.remove(classNames.stageOpen);

	toggleHighlightColorScheme();

	window.removeEventListener('click', checkForNavOutsideClicks);
};

const checkForNavOutsideClicks = (e) => {
	if (!e.target.closest(selectors.lvl1LiMain)?.classList.contains(classNames.lvlOpen)) {
		closeStage();

		if (window.scrollY === 0) {
			elements.nav.classList.remove(classNames.bg);
		}
	}
};

// Handle click for primary level nav items
document.querySelectorAll(`${selectors.primaryNavSelector}.${classNames.lvlSubmenu} > a`).forEach((el) => {
	handleNavClick(el, selectors.primaryNavSelector, selectors.lvl1Li, true);
});

const openThirdLvlMenu = (el) => {
	const id = el.id;
	el.classList.add(classNames.lvlFocus);
	const targetMenu = el.closest(selectors.lvl1Li).querySelector(specificLvlThree(id));
	targetMenu && targetMenu.classList.add(classNames.lvlOpen);
};

const setSubNavOffset = () => {
	if (elements.nav) {
		const headerNavRect = elements.nav.getBoundingClientRect();
		elements.nav.style.setProperty('--subnav-offset', `${headerNavRect.top + headerNavRect.height}px`);
	}
};

// Update subnav offset when
// 1. window is scrolled
// 2. the body dimensions changed
(() => {
	setSubNavOffset();
	window.addEventListener('scroll', () => {
		setSubNavOffset();
	});

	const resizeObserver = new ResizeObserver(setSubNavOffset);
	resizeObserver.observe(document.body);
})();

// Handle 2nd level nav items in desktop mega menu.
document.querySelectorAll(selectors.stages).forEach((stage) => {
	const secondLvlNavAncestor = stage.querySelectorAll(`${selectors.secondLvlNavItems} a.current-menu-ancestor`);
	const secondLvlNavItems = stage.querySelectorAll(`${selectors.secondLvlNavItems} > a.menu-item-has-children`);

	const addSecondLvlNavLinkListener = (link) => {
		// Add click event listener.
		link.addEventListener('click', () => {
			if (!link.classList.contains(classNames.lvlFocus)) {
				// Remove focus class from 2nd level nav items.
				secondLvlNavItems.forEach((el) => el.classList.remove(classNames.lvlFocus));

				// Close all 3rd level nav menus.
				stage.querySelectorAll(selectors.thirdLvlNavMenus).forEach((menu) => menu.classList.remove(classNames.lvlOpen));
				setTimeout(() => {
					openThirdLvlMenu(link);
				}, 250);
			}
		});
	};

	if (secondLvlNavAncestor.length) {
		// Activate the second level navigation point which third level navigation point is active.
		openThirdLvlMenu(secondLvlNavAncestor[0]);
	} else if (secondLvlNavItems.length) {
		// Activate first 2nd lvl nav item and related 3rd level nav menu.
		openThirdLvlMenu(secondLvlNavItems[0]);
	}

	// Close stage after click on an anchor link.
	stage.querySelectorAll('a[href*="#"]').forEach((el) => {
		el.addEventListener('click', closeStage);
	});

	secondLvlNavItems.forEach((link) => {
		addSecondLvlNavLinkListener(link);
	});
});

// Handle click for 2nd level mobile nav items.
document.querySelectorAll(`${selectors.mobileNavSelector}.${classNames.lvlSubmenu} > a`).forEach((el) => {
	handleNavClick(el, selectors.mobileNavSelector, selectors.lvl1Li);
});

elements.nav && initScrollEvents();
